import React from 'react';
import { Box, Stack, TextField, MenuItem, Typography } from '@mui/material';
import { ethiopianClockParts, fromEthiopianClock } from './clockSystem';

// Value and changes always use canonical 24-hour local time, never display labels.
export default function EthiopianTimeField({ label, value, onChange, error, disabled, showStandard = false }) {
  const parts = ethiopianClockParts(value);
  const update = (field, next) => {
    const p = { ...(parts || { hour: 12, minute: 0, period: 'daytime' }), [field]: next };
    onChange(fromEthiopianClock(p.hour, p.minute, p.period));
  };
  return <Box sx={{ minWidth: 235 }}>
    <Typography variant="caption">{label} — Ethiopian time</Typography>
    <Stack direction="row" spacing={0.5}>
      <TextField select size="small" label="Hour" value={parts?.hour ?? ''} disabled={disabled} error={error} onChange={e => update('hour', Number(e.target.value))} sx={{ minWidth: 65 }}>
        {Array.from({ length: 12 }, (_, i) => <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>)}
      </TextField>
      <TextField select size="small" label="Minute" value={parts?.minute ?? ''} disabled={disabled} error={error} onChange={e => update('minute', Number(e.target.value))} sx={{ minWidth: 72 }}>
        {Array.from({ length: 60 }, (_, i) => <MenuItem key={i} value={i}>{String(i).padStart(2, '0')}</MenuItem>)}
      </TextField>
      <TextField select size="small" label="Period" value={parts?.period ?? ''} disabled={disabled} error={error} onChange={e => update('period', e.target.value)} sx={{ minWidth: 110 }}>
        <MenuItem value="daytime">Daytime</MenuItem><MenuItem value="nighttime">Nighttime</MenuItem>
      </TextField>
    </Stack>
    <Typography variant="caption" color={error ? 'error' : 'text.secondary'}>{error ? 'Invalid time range. ' : ''}{value ? (showStandard ? `Standard time: ${Number(value.slice(0,2)) % 12 || 12}:${value.slice(3)} ${Number(value.slice(0,2)) < 12 ? 'AM' : 'PM'}` : '') : 'Choose a time'}</Typography>
  </Box>;
}
